<template>
  <div id="app">
    <div id="nav">
      <van-tabbar v-if="ifActivePage" router v-model="active" active-color="#E95513" inactive-color="#000000"
        @change="onChange">
        <van-tabbar-item to="/active/jingyue" name="activeIndex" icon="medal">赛事首页</van-tabbar-item>
        <van-tabbar-item to="/active/user" name="activeUser" icon="friends">个人中心</van-tabbar-item>
        <!-- <van-tabbar-item to="/index" name="index" icon="wap-home">首页</van-tabbar-item>
                <van-tabbar-item to="/gameList" name="game" icon="hot">赛事</van-tabbar-item>
                <van-tabbar-item to="/newsList" name="news" icon="comment">新闻</van-tabbar-item> -->
      </van-tabbar>
      <van-tabbar v-else router v-model="active" active-color="#e50021" inactive-color="#000000" @change="onChange">
        <van-tabbar-item to="/index" name="index" icon="wap-home">首页</van-tabbar-item>
        <van-tabbar-item to="/gameList" name="game" icon="hot">赛事</van-tabbar-item>
        <van-tabbar-item to="/newsList" name="news" icon="comment">新闻</van-tabbar-item>
        <van-tabbar-item to="/user" name="user" icon="friends">我的</van-tabbar-item>
      </van-tabbar>
    </div>
    <router-view />
  </div>
</template>
<script>
  import { Tabbar, TabbarItem } from "vant";
  export default {
    name: "Home",
    components: {
      [Tabbar.name]: Tabbar,
      [TabbarItem.name]: TabbarItem,
    },
    data() {
      return {
        active: "index",
        ifActivePage: false,
      };
    },
    computed: {},
    mounted() {
      this.initBottomBar(window.location.href);
    },
    methods: {
      onChange(index) {
        this.active = index;
      },
      initBottomBar(url) {
        this.ifActivePage = url.includes("/active/") ? true : false;
        if (url.includes("/game")) {
          this.active = "game";
        }
        if (url.includes("/news")) {
          this.active = "news";
        }
        if (
          url.includes("/user") ||
          url.includes("/myGame") ||
          url.includes("/myInfo") ||
          url.includes("/myCertificate")
        ) {
          this.active = "user";
        }

        if (
          url.includes("/active/index") ||
          url.includes("/active/gameSignUp") ||
          url.includes("/active/gameDetail") ||
          url.includes("/active/newsDetail") ||
          url.includes("/active/searchList")
        ) {
          this.active = "activeIndex";
        }
        if (
          url.includes("/active/user") ||
          url.includes("/active/pay") ||
          url.includes("/active/login") ||
          url.includes("/active/myInfo") ||
          url.includes("/active/myGame")
        ) {
          this.active = "activeUser";
        }
      },
    },
  };
</script>
<style lang="less">
  * {
    box-sizing: border-box;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding-bottom: 84px;
    overflow: auto;
  }

  #cnzz_stat_icon_1279948713 {
    display: none;
  }

  body {
    margin: 0;
  }

  ul,
  li {
    list-style: none;
    padding-inline-start: 0;
    margin: 0;
  }

  .van-tabbar--fixed {
    border-top: 1px solid #ce3939;
  }

  .m-color {
    color: #ce3939;
  }

  .b-color {
    background-color: #ce3939;
  }

  .font12 {
    font-size: 12px;
  }

  .font14 {
    font-size: 14px;
  }

  .font16 {
    font-size: 16px;
  }

  .font18 {
    font-size: 18px;
  }

  .font20 {
    font-size: 20px;
  }

  .mt10 {
    margin-top: 10px;
  }

  .mr10 {
    margin-right: 10px;
  }

  .ml10 {
    margin-left: 10px;
  }

  .mb10 {
    margin-bottom: 10px;
  }

  .mt25 {
    margin-top: 25px;
  }

  .mr20 {
    margin-right: 20px;
  }

  .left {
    float: left;
  }

  .right {
    float: right;
  }

  .text-center {
    text-align: center !important;
  }

  .hide {
    display: none;
  }
</style>